<template>
  <div>
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
              Usuarios aprobadores
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right">
              <button class="faccess_button" @click="modal_create = true">
                CREAR USUARIO
              </button>
            </v-flex>
            <div class="buttom_reload" @click="getApprovedUsers()">
              <img src="@/assets/img/icons/refresh-icon.svg" />
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-data-table
          v-model="approved_users"
          :headers="options_table.headers_table"
          :items="approved_users"
          :pagination.sync="options_table.pagination"
          select-all
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  options_table.pagination.descending ? 'desc' : 'asc',
                  header.value === options_table.pagination.sortBy
                    ? 'active'
                    : ''
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-center">
                {{ props.item.attributes.user_email }}
              </td>
              <td class="text-xs-center">
                {{ props.item.attributes.department_name }}
              </td>
              <td class="text-xs-center">
                <span v-for="location in props.item.attributes.location_names"
                  >{{ location }}<br
                /></span>
              </td>
              <td class="text-xs-center">
                <button @click="showModalInEditMode(props.item)">
                  Editar
                </button>
              </td>
              <!-- <td class="text-xs-center">
              <a @click.prevent="showConfirmModal(props.item.id)">
                Eliminar
              </a>
            </td> -->
            </tr>
          </template>
        </v-data-table>
      </div>

      <section v-if="show_confirm_modal" class="access_devices__modal">
        <section class="access_devices__modal--container" style="width: 40%;">
          <p class="access_devices__modal--text">
            ¿Está seguro de eliminar el departamento?
          </p>
          <div class="access_devices__modal--buttons" style="margin-top: 1rem;">
            <div
              class="access_devices__modal--button"
              @click="closeConfirmModal"
            >
              Cancelar
            </div>
            <div
              class="access_devices__modal--button active"
              @click="deleteUserCategory"
            >
              Si
            </div>
          </div>
        </section>
      </section>
    </div>

    <template>
      <!-- create department dialog -->
      <v-dialog v-model="modal_create" persistent max-width="424px">
        <v-card>
          <div class="invitation__new">
            <div class="invitation__new--title">
              <p class="invitation__new_text--title">
                {{
                  is_editing
                    ? "Editar usuario aprovador"
                    : "Crear usuario aprobador"
                }}
              </p>
            </div>
            <div class="invitation__new--info_container">
              <v-flex xs12>
                <v-select
                  v-model="new_user_approved.user_id"
                  :items="all_users"
                  item-value="id"
                  item-text="attributes.email"
                  label="Usuario aprobador"
                  v-validate="'required'"
                  name="user_field"
                  flat
                >
                </v-select>

                <p
                  v-show="errors.has('user_field')"
                  class="invitation__new--error_message"
                >
                  Selecciona un usuario aprobador
                </p>
              </v-flex>

              <v-flex xs12>
                <v-select
                  v-model="new_user_approved.approval_department_id"
                  :items="approval_departments"
                  item-text="attributes.name"
                  item-value="id"
                  label="Departamento aprobador"
                  v-validate="'required'"
                  name="approval_department_field"
                  flat
                >
                </v-select>

                <p
                  v-show="errors.has('approval_department_field')"
                  class="invitation__new--error_message"
                >
                  Selecciona un departamento
                </p>
              </v-flex>

              <v-flex xs12>
                <v-select
                  v-model="new_user_approved.approved_locations"
                  :items="available_locations"
                  item-text="name"
                  item-value="location_id"
                  label="Locasiones asociadas"
                  v-validate="'required'"
                  name="approved_locations_field"
                  flat
                  hide-details
                  small
                  multiple
                  clearable
                >
                </v-select>
                <p
                  v-show="errors.has('approved_locations_field')"
                  class="invitation__new--error_message"
                >
                  Selecciona una locación
                </p>
              </v-flex>

              <div class="invitation__new--actions">
                <p
                  class="invitation__buttons--blue"
                  @click="createUserApproved()"
                >
                  ENVIAR
                </p>
                <p
                  class="invitation__buttons--gray"
                  @click="closeCreateModal()"
                >
                  CANCELAR
                </p>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      available_locations: [],
      approval_departments: [],
      search: "",
      is_editing: false,
      modal_create: false,
      new_user_approved: {
        current_user_id: this.getUserId(),
        role_name: "approval_user",
        user_id: "",
        company_id: this.getCompany().id,
        approved_locations: [],
        approval_department_id: ""
      },
      options_table: {
        pagination: {
          sortBy: "name",
          rowsPerPage: 10
        },
        headers_table: [
          {
            text: "Correo",
            align: "center",
            value: "user_email"
          },
          {
            text: "Departamento Validador",
            align: "center",
            value: "department_name"
          },
          {
            text: "Locaciones asociadas",
            align: "center",
            value: "location_names"
          },
          {
            text: "Actualizar",
            align: "center",
            value: "update"
          }
          // {
          //   text: "Eliminar",
          //   align: "center",
          //   value: "delete"
          // }
        ],
        filters: {
          access_state: []
        }
      },
      approval_departments: [],
      show_confirm_modal: false,
      user_category_to_delete: null,
      approved_users: [],
      all_users: [],
    };
  },
  mounted() {
    this.getAllUsers();
    this.getApprovedUsers();
    this.getApprovalDepartments();
    this.getLocations();
  },
  methods: {
    getApprovalDepartments() {
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .get("approval_department", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params: {
              data: {
                user_id: this.getUserId(),
                company_id: this.getCompany().id
              }
             
            }
          })
          .then(function(response) {
            this.approval_departments = response.body.data;
          });
      } catch (e) {
        alert(e);
      }
    },
    getLocations() {
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .post(
            "locations/company",
            { data: this.encrypt(data).toString() },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken()
              }
            }
          )
          .then(function(response) {
            this.sortAvailableLocations(response.body);
          });
      } catch (e) {
        alert(e);
      }
    },
    sortAvailableLocations(dataResponse) {
      this.available_locations = [];
      for (var i = 0; i < dataResponse.data.length; i++) {
        if (dataResponse.data[i].attributes.published == true) {
          this.available_locations.push({
            location_id: parseInt(dataResponse.data[i].id),
            name: dataResponse.data[i].attributes.name
          });
        }
      }
    },
    createUserApproved() {
      this.$validator.validateAll().then(result => {
        if (!result) return;
        const url = this.is_editing
          ? "approved_user/" + this.new_user_approved.approved_user_id
          : "approved_user";
        const method = this.is_editing ? "put" : "post";
        const payload = {
          data: this.encrypt(this.new_user_approved).toString()
        };
        const headers = {
          "X-Device-ID": this.getDeviceId(),
          Authorization: "Bearer " + this.getUserToken()
        };
        try {
          this.$http[method](url, payload, { headers }).then(
            function(response) {
              this.datePickerFirstClick2 = false;
              this.modal_create = false;
              this.updateAlertMessage(response.body.ans);
              this.updateIsInAlert(true);
              this.getApprovedUsers();
              this.getApprovalDepartments();
              this.clearNewApprovedUserData();
              this.is_editing = false;
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            },
            function(response) {
              if (typeof response.body.errors[0].details != "object") {
                this.updateAlertMessage(response.body.errors[0].details);
                this.updateIsInAlert(true);
              } else {
                let message = [];
                for (var key in response.body.errors[0].details) {
                  message.push(response.body.errors[0].details[key]);
                }
                this.updateAlertMessage(message);
                this.updateIsInAlert(true);
              }
            }
          );
        } catch (e) {
          alert(e.message);
        }
      });
    },
    changeSort (column) {
      if (this.options_table.pagination.sortBy === column) {
        this.options_table.pagination.descending = !this.options_table.pagination.descending
      } else {
        this.options_table.pagination.sortBy = column
        this.options_table.pagination.descending = false
      }
    },
    clearNewApprovedUserData() {
      this.$validator.reset();
      this.new_user_approved = {
        approved_user_id: undefined,
        current_user_id: this.getUserId(),
        role_name: "approval_user",
        user_id: "",
        company_id: this.getCompany().id,
        approved_locations: [],
        approval_department_id: ""
      };
    },
    closeCreateModal() {
      this.modal_create = false;
      if (this.is_editing) {
        this.clearNewApprovedUserData();
        this.is_editing = false;
      }
    },
    showModalInEditMode(user) {
      this.modal_create = true;
      this.is_editing = true;

      const filteredUser = this.approved_users.find(us => {
        return us.id === user.id;
      });
      this.new_user_approved.approval_department_id =
        filteredUser.id;
      this.new_user_approved.user_id = filteredUser.attributes.user_id;
      this.new_user_approved.approved_locations =
        filteredUser.attributes.approved_locations;
      this.new_user_approved.approved_user_id = filteredUser.id;
    },
    locationsNames(arr) {
      let locations = this.available_locations.filter(loc => {
        return arr.includes(loc.location_id);
      });
      let locationStr = "";
      locations.map(loc => {
        locationStr += locationStr == "" ? loc.name : `, ${loc.name}`;
      });
      locationStr =
        locationStr != ""
          ? locationStr
          : "<b>EL PLAN NO POSEE ACCESO A NINGUNA SEDE</b>";
      return locationStr;
    },
    deleteUserCategory() {
      this.$http
        .delete("user_categories/destroy", {
          headers: {
            "X-Device-ID": this.getDeviceId(),
            Authorization: "Bearer " + this.getUserToken()
          },
          params: {
            id: this.user_category_to_delete,
            company_id: this.getCompany().id
          }
        })
        .then(function(response) {
          this.updateAlertMessage(
            "Plan de usuario eliminado satisfactoriamente"
          );
          this.updateIsInAlert(true);
          this.getUsersCategories();
        })
        .catch(function(response) {
          this.updateAlertMessage(response.body.errors[0].title);
          this.updateIsInAlert(true);
        });

      this.closeConfirmModal();
    },
    getApprovedUsers() {
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .get("approved_user/index_approvers", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params: {
              data: {
                user_id: this.getUserId()
              }
            }
          })
          .then(function(response) {
            this.approved_users = response.body.data;
          });
      } catch (e) {
        alert(e);
      }
    },
    getAllUsers() {
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .get("approved_user/index_users", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params: {
              data: {
                user_id: this.getUserId()
              }
            }
          })
          .then(function(response) {
            this.all_users = response.body.data;
          });
      } catch (e) {
        alert(e);
      }
    },
    showConfirmModal(userCategoryId) {
      this.user_category_to_delete = userCategoryId;
      this.show_confirm_modal = true;
    },
    closeConfirmModal() {
      this.user_category_to_delete = null;
      this.show_confirm_modal = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/invitations/business_invitations/ApprovedUsers.vue